import { getCookie, removeCookie, setCookie } from '@ecster/cookies';

export const ORIGIN_COOKIE = 'ecster-origin-id';

export const createOriginCookie = () => {
    const originId = crypto.randomUUID().replaceAll('-', '');
    setCookie(ORIGIN_COOKIE, originId, 1);
    return originId;
};

export const getOriginCookie = () => {
    return getCookie(ORIGIN_COOKIE);
};

export const deleteOriginCookie = () => {
    removeCookie(ORIGIN_COOKIE);
};
